import { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import MenuItem from "@mui/material/MenuItem";

// import {vehicleTrunkTypes} from 'services/constants';
import MySelectField from "components/Inputs/MySelectField";

const VehicleTrunkTypeSelect = (props) => {
  const { t } = useTranslation();
  const { enums, value, updateValues } = props;

  const [vehicleTrunkTypes, setVehicleTrunkTypes] = useState();

  useEffect(() => {
    if (enums) {
      setVehicleTrunkTypes(enums?.data?.vehicles?.car?.trunk_type);
    }
  }, [enums]);

  const handleSelectChange = ({ target }) => {
    updateValues({ [target.name]: target.value });
  };

  return (
    <Fragment>
      <MySelectField
        id="select_order_type"
        name="trunk_type"
        value={value ? value : 0}
        onChange={handleSelectChange}
      >
        {vehicleTrunkTypes
          ? vehicleTrunkTypes.map((option) => (
              <MenuItem key={option.key} value={option.key}>
                {t(option.value)}
              </MenuItem>
            ))
          : null}
      </MySelectField>
    </Fragment>
  );
};

export default VehicleTrunkTypeSelect;
